import { useOptionalTheme } from './chunk-EOFYHHEG.js';
import { Tooltip, TooltipTrigger, TooltipContent } from './chunk-K4S4BS2H.js';
import { Button } from './chunk-PLP233UC.js';
import { cn } from './chunk-FFX3LZW7.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Sun, Moon } from 'lucide-react';

var SIZE_CLASSES = {
  sm: "size-7 text-xs rounded-md",
  md: "size-9 text-sm rounded-lg",
  lg: "size-10 text-base rounded-xl"
};
function BrandMark({ className, size = "md" }) {
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: cn(
        "inline-flex shrink-0 items-center justify-center bg-brand font-bold text-brand-foreground shadow-xs select-none",
        SIZE_CLASSES[size],
        className
      ),
      "aria-hidden": true,
      children: "A"
    }
  );
}
function ThemeToggle({
  className,
  size = "icon",
  variant = "ghost",
  withTooltip = true
}) {
  const theme = useOptionalTheme();
  if (!theme) return null;
  const { resolvedMode, setMode } = theme;
  const next = resolvedMode === "dark" ? "light" : "dark";
  const label = `Switch to ${next} theme`;
  const button = /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      variant,
      size,
      "aria-label": label,
      className: cn(
        size === "icon" ? "size-8" : "h-8 px-2",
        "text-muted-foreground transition-colors hover:text-foreground",
        className
      ),
      onClick: () => setMode(next),
      children: resolvedMode === "dark" ? /* @__PURE__ */ jsx(Sun, { className: "size-4" }) : /* @__PURE__ */ jsx(Moon, { className: "size-4" })
    }
  );
  if (!withTooltip) return button;
  return /* @__PURE__ */ jsxs(Tooltip, { children: [
    /* @__PURE__ */ jsx(TooltipTrigger, { asChild: true, children: button }),
    /* @__PURE__ */ jsx(TooltipContent, { side: "bottom", children: label })
  ] });
}

export { BrandMark, ThemeToggle };
//# sourceMappingURL=chunk-YLFHP5LL.js.map
//# sourceMappingURL=chunk-YLFHP5LL.js.map